import { ReactNode } from "react";
import { useUser } from "../../context/UserContext";
import PlatformStreakIndicator from "../PlatformStreakIndicator";
import {
  EMPTY_PLATFORM_SUMMARY,
  platformSummaryToStreakStats,
} from "../../constants/dashboardStats";
import "./Topbar.scss";

import profileIcon from "../../assets/profile-icon.svg";
import { Dropdown, Image, NavDropdown } from "react-bootstrap";

export const Topbar = (props: {
  title: string;
  titleAddon?: ReactNode;
}): JSX.Element => {
  const { user, logout, platformSummary } = useUser();
  const studentView = user?.type === "student";
  const streakStats = platformSummaryToStreakStats(platformSummary ?? EMPTY_PLATFORM_SUMMARY);

  const UserMenu = (
    <Image
      src={profileIcon}
      alt="UserName profile image"
      roundedCircle
      style={{ width: "30px" }}
    />
  );

  return (
    <div id="topBar">
      <div className="topbar-title-area">
        <h1>{props.title}</h1>
        {props.titleAddon}
      </div>
      <div className="topbar-actions">
        {studentView ? <PlatformStreakIndicator stats={streakStats} /> : null}
        <div id="profileAreaWrapper">
          <div id="profileArea">
            <NavDropdown id="nav-dropdown" title={UserMenu}>
              <Dropdown.Header>{user?.firstName} {user?.lastName}</Dropdown.Header>
              <Dropdown.Divider />
              <Dropdown.Item eventKey="1" onClick={logout}>Logout</Dropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};
